<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="900px"
        title="Order Detail"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <div class="order-detail-header">
                <p class="order-num" style="font-size:20px">Order <span :class="{'sn':orderDetail.ship_cost > 0 ? true : false}">#{{ orderDetail.plt_order_sn }}</span></p>
                <!-- <p class="print-order"><i class="el-icon-printer"></i> Print Order</p> -->
                <p class="order-state">
                    <i class="el-icon-s-help"></i>{{ orderDetail.status_name }}
                </p>
                <p v-if="orderDetail.import == 0"> API</p>
                <p v-else-if="orderDetail.import == 1"> Manual</p>
                <p v-else> Shopping Cart</p>
                <p class="order-date">
                    Created On: {{ orderDetail.plt_create_time }}
                </p>
            </div>
            <el-alert
                v-if="orderDetail.status == 50 && orderDetail.abnormal_remark"
                :title="orderDetail.abnormal_remark"
                type="error"
                show-icon
                :closable="false"
                style="margin-bottom: 10px"
            >
            </el-alert>
            <el-alert
                v-if="orderDetail.is_sync_platfrom == 2 && orderDetail.fail_sync_platfrom"
                :title="'Logistics return failed : '+orderDetail.fail_sync_platfrom"
                type="error"
                show-icon
                :closable="false"
                style="margin-bottom: 10px"
            >
            </el-alert>
            <div class="order-detail-body">
                <div class="order-detail-body-item">
                    <!-- <div class="order-detail-body-title">Order Information</div> -->
                    <div class="order-detail-body-label">Shipping Address</div>
                    <div class="order-detail-body-value" v-html="orderDetail.orders_address.buyer_name">
                    </div>
                    <div class="order-detail-body-value">
                        {{
                            orderDetail.orders_address.street1 +
                            orderDetail.orders_address.street2
                        }}
                    </div>
                    <div class="order-detail-body-value">
                        {{
                            orderDetail.orders_address.city +
                            " " +
                            orderDetail.orders_address.state +
                            " " +
                            orderDetail.orders_address.postal_code
                        }}
                    </div>
                    <div class="order-detail-body-value">
                        {{ orderDetail.country }}
                    </div>
                    <div class="order-detail-body-value">
                        {{ orderDetail.orders_address.phone }}
                    </div>
                    <template>
                        <div class="order-detail-body-label">
                            Shipping Method
                        </div>
                        <div class="order-detail-body-value">
                            {{ orderDetail.last_mile }}
                            <span
                                style="opacity: 0.8"
                                v-if="orderDetail.express_name"
                                >({{ orderDetail.express_name }})</span
                            >
                        </div>
                        <div
                            class="tracking_number"
                            v-if="orderDetail.tracking_number"
                        >   <span @click="toTracking(orderDetail)">
                            <i class="el-icon-link"></i>
                            {{ orderDetail.tracking_number }}
                            </span>
                            <i class="el-icon-document-copy"  @click="copy(orderDetail,'tracking_number')"></i>
                        </div>
                        <div
                            class="order-detail-body-value"
                            v-if="orderDetail.shiped_time"
                        >
                            Shiped Time: {{ orderDetail.shiped_time }}
                        </div>
                    </template>
                    <template v-if="orderDetail.remark">
                        <div class="order-detail-body-label">Remark</div>
                        <div
                            class="order-detail-body-value"
                            v-html="orderDetail.remark"
                        >
                            <!-- {{ orderDetail.remark }} -->
                        </div>
                    </template>
                </div>
                <div class="order-detail-body-item">
                    <template v-if="orderDetail.payment_method">
                        <div class="order-detail-body-label">
                            Payment Method
                        </div>
                        <div class="order-detail-body-value">
                            {{ orderDetail.payment_method }}
                        </div>
                    </template>
                    <template v-if="+orderDetail.refund_amount > 0">
                        <div class="order-detail-body-label">Refund</div>
                        <div class="order-detail-body-value color-danger">
                            {{
                                orderDetail.currency + orderDetail.refund_amount
                            }}
                        </div>
                    </template>
                    <template v-if="orderDetail.ioss">
                        <div class="order-detail-body-label">IOSS</div>
                        <div class="order-detail-body-value color-danger">
                            {{ orderDetail.ioss }}
                        </div>
                    </template>
                </div>
            </div>
            <div class="table-wrapper">
                <el-table
                    ref="shippingTable"
                    :data="orderDetail.orders_goods"
                    style="width: 100%"
                    header-cell-class-name="header-cell-class-name"
                    cell-class-name="cell-class-name"
                    :cell-style="cellStyle"
                >
                    <el-table-column label="Item" width="510">
                        <template slot-scope="scope">
                            <div class="goods-info-wrapper">
                                <el-image
                                    class="elImage_show"
                                    :src="scope.row.image"
                                    fit="contain"
                                    :lazy="true"
                                >
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                    <div slot="placeholder" class="image-slot">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                </el-image>
                                <div class="info-wrapper">
                                    <div class="goods-name ellipsis-2">
                                        {{ scope.row.goods_name }}
                                    </div>
                                    <div class="sku-div">
                                        <span>SKU:</span>
                                        <span
                                            class="sku"
                                            v-if="scope.row.sku && scope.row.sku.length < 33"
                                            >{{ scope.row.sku }}</span
                                        >
                                        <el-tooltip
                                            effect="dark"
                                            :content="scope.row.sku"
                                            placement="top"
                                            popper-class="set_tooltip"
                                            v-else
                                        >
                                            <span class="sku">{{
                                                scope.row.sku
                                            }}</span>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" :content="`SKU ${scope.row.sku} does not exist`" placement="top-start">
                                        <img
                                            src="@/assets/image/warning.svg"
                                            v-if="scope.row.sku_drop == 0"
                                            class="warning-svg"
                                        />
                                        </el-tooltip>
                                        <img
                                            src="@/assets/image/source.png"
                                            v-if="scope.row.delivery_type"
                                            class="source-svg"
                                        />
                                        <!-- <span
                                            class="delivery-type"
                                            v-if="scope.row.delivery_type"
                                            >{{ scope.row.delivery_type }}</span
                                        > -->
                                    </div>
                                    <div class="attr_value">
                                        {{ scope.row.attr_value }}
                                    </div>
                                    <template v-if="scope.row.is_combine_sku == 2">
                                        <div
                                            class="goods-attribute"
                                            v-for="item of Object.entries(
                                                scope.row.custom_properties
                                            )"
                                            :key="item[0]"
                                        >
                                            <p class="goods-attribute-label">
                                                {{ item[0] }}:
                                            </p>
                                            <el-tooltip
                                                v-if="item[1].length > 35"
                                                placement="right"
                                                :popper-class="[
                                                    item[1].split(',').length > 2
                                                        ? 'photo_set_tooltip lot_photos'
                                                        : 'photo_set_tooltip',
                                                ]"
                                            >
                                                <div slot="content">
                                                    <span
                                                        v-if="!isImlUrl(item[1])"
                                                        v-html="item[1]"
                                                    >
                                                    </span>
                                                    <div
                                                        class="tooltip_photo_set"
                                                        v-else
                                                    >
                                                        <el-image
                                                            v-for="url in item[1].split(
                                                                ','
                                                            )"
                                                            :key="url"
                                                            class="elImage_show"
                                                            fit="contain"
                                                            :src="url.split('<br/>').join('')"
                                                        >
                                                            <div
                                                                slot="error"
                                                                class="image-slot"
                                                            >
                                                                <i
                                                                    class="
                                                                        el-icon-picture-outline
                                                                    "
                                                                ></i>
                                                            </div>
                                                            <div
                                                                slot="placeholder"
                                                                class="image-slot"
                                                            >
                                                                <i
                                                                    class="
                                                                        el-icon-loading
                                                                    "
                                                                ></i>
                                                            </div>
                                                        </el-image>
                                                    </div>
                                                </div>
                                                <p
                                                    class="
                                                        goods-attribute-value
                                                        ellipsis
                                                    "
                                                >
                                                    <span
                                                        v-if="!isImlUrl(item[1])"
                                                        v-html="item[1]"
                                                    ></span>
                                                    <!-- <i
                                                        v-else
                                                        class="
                                                            detail-thumb
                                                            el-icon-picture-outline
                                                        "
                                                    ></i> -->
                                                    <img
                                                        v-else
                                                        class="detail-thumb"
                                                        :src="
                                                            require('@/assets/image/order/img-thumb.svg')
                                                        "
                                                        alt=""
                                                    />
                                                </p>
                                            </el-tooltip>
                                            <p
                                                v-else
                                                class="goods-attribute-value"
                                                v-html="item[1]"
                                            ></p>
                                        </div>
                                    </template>
                                    <template v-if="scope.row.is_combine_sku == 1">
                                        <div
                                            v-for="(item,index) in scope.row.combine_custom_properties"
                                            :key="index"
                                        >
                                            
                                                <div v-if="item.custom" style="padding:2px 10px;background-color:rgb(238, 242, 254);">Custom {{index+1}}</div>
                                                <div v-for="(v,k) in item.custom" :key="k"  style="padding: 5px 0 0 10px;">
                                                    <div v-if="isAnImage(v)">
                                                        {{k}} : <el-image
                                                            :src="ossImg(v, 80, 80)"
                                                            :preview-src-list="[ossImg(v, 800, 800)]"
                                                            fit="contain"
                                                            :lazy="true"
                                                        ></el-image>
                                                    </div>
                                                    <div v-else>{{k}} : {{v}}</div>
                                                </div>
                                            
                                        </div>
                                    </template>
                                    <div
                                        class="goods-remark"
                                        v-if="
                                            scope.row.remark != ' ' &&
                                            scope.row.remark
                                        "
                                    >
                                        {{ scope.row.remark }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Quantity"
                        prop="goods_num"
                        align="center"
                    ></el-table-column>
                    <el-table-column label="Price">
                        <template slot-scope="scope">
                            <div>
                                {{
                                    orderDetail.currency + scope.row.goods_price
                                }}
                            </div>
                            <div
                                style="margin-top: 20px"
                                v-if="orderDetail.platform_id != 5"
                            >
                                ({{ "$" + scope.row.act_price }})
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Subtotal">
                        <template slot-scope="scope">
                            <div>
                                {{
                                    orderDetail.currency +
                                    (
                                        scope.row.goods_price *
                                        scope.row.goods_num
                                    ).toFixed(2)
                                }}
                            </div>
                            <div
                                style="margin-top: 20px; color: #9b3c44"
                                v-if="orderDetail.platform_id != 5"
                            >
                                ({{
                                    "$" +
                                    (
                                        scope.row.act_price *
                                        scope.row.goods_num
                                    ).toFixed(2)
                                }})
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="checkout-wrapper">
                <div class="checkout-box">
                    <div class="subtotal">
                        <p class="subtotal-label">Discount</p>
                        <p class="subtotal-value">
                            -{{
                                orderDetail.currency +
                                (orderDetail.platform_id != 5
                                    ? orderDetail.order_discount
                                    : orderDetail.discount)
                            }}
                        </p>
                    </div>
                    <div class="subtotal">
                        <p class="subtotal-label">Shipping Fee</p>
                        <p class="subtotal-value">
                            {{ orderDetail.currency + orderDetail.ship_cost }}
                        </p>
                    </div>
                    <div
                        class="subtotal"
                        v-if="orderDetail.ioss_fee !== '0.00'"
                    >
                        <p class="subtotal-label">IOSS</p>
                        <p class="subtotal-value">
                            {{ orderDetail.currency + orderDetail.ioss_fee }}
                        </p>
                    </div>
                    <div
                        class="subtotal"
                        v-if="orderDetail.insure_fee !== '0.00'"
                    >
                        <p class="subtotal-label">Insure Fee</p>
                        <p class="subtotal-value">
                            {{ orderDetail.currency + orderDetail.insure_fee }}
                        </p>
                    </div>
                    <div class="subtotal">
                        <p class="subtotal-label">Tax</p>
                        <p class="subtotal-value">
                            {{ orderDetail.currency + orderDetail.taxes }}
                        </p>
                    </div>
                    <div class="total">
                        <p class="total-label">Total</p>
                        <p class="total-value">
                            {{
                                orderDetail.currency + orderDetail.order_amount
                            }}
                        </p>
                    </div>
                    <template v-if="orderDetail.platform_id != 5">
                        <el-divider></el-divider>
                        <div class="subtotal">
                            <p class="subtotal-label">Discount</p>
                            <p class="subtotal-value">
                                -{{ "$" + orderDetail.discount }}
                            </p>
                        </div>
                        <div class="subtotal">
                            <p class="subtotal-label">Act Shipping Fee</p>
                            <p class="subtotal-value">
                                {{ "$" + orderDetail.act_ship_cost }}
                            </p>
                        </div>
                        <div class="paid-amount">
                            <p class="paid-amount-label">Total Resale Price</p>
                            <p class="paid-amount-value">
                                {{ "$" + orderDetail.act_amount }}
                            </p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            tableData: [],
            subtotal: 0,
            total: 0,
            paidAmound: 0,
            orderDetail: {
                orders_address: {},
                orders_goods: [],
            },
        };
    },
    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            /* if (columnIndex == 1 ||  columnIndex == 3) {
                return { color: "#9b3c44" };
            }*/
        },
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        isAnImage(filePath){
            //获取最后一个.的位置
            var index= filePath.lastIndexOf(".");
            //获取后缀
            var ext = filePath.substr(index+1)
            return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
        },
        getOrderDetail() {
            cmofferApi.orders({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    // console.log(res);
                    this.orderDetail = { ...res.data, orders_address: res.data.orders_address || {}};
                    this.orderDetail.orders_goods.forEach((item) => {
                        // \n 转 br
                        if (Object.keys(item.custom_properties).length > 0) {
                            for (let k in item.custom_properties) {
                                item.custom_properties[k] = item.custom_properties[k].split("\n").join("<br/>");
                            }
                        }
                    });
                }
            });
        },
        toTracking(row) {
            let { tracking_number, last_mile, express_name } = row;
            let src = `${
                last_mile == "USPS-ST" || express_name.toUpperCase() == "USPS"
                    ? "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1="
                    : "https://t.17track.net/en#nums="
            }`;
            window.open(`${src + tracking_number}`);
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        detailVisible() {
            if (this.detailVisible) {
                this.getOrderDetail();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    .color-danger {
        color: $color-danger;
    }
    .order-detail-header {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 30px 0;
        padding-left: 10px;
        .order-num {
            font-size: 26px;
        }
        .print-order {
            color: $color-danger;
            margin: 0 30px;
        }
        .order-state {
            color: $color-danger;
            margin: 0 30px;
        }
        .order-date {
            margin-left:10px;
            color: $color-333333;
        }
    }
    .order-abnormal-remark {
        border: 1px solid #ffdbdb;
        background: #fef0f0;
        color: $color-danger;
        padding: 10px 2px 10px 5px;
        font-size: 12px;
        margin-bottom: 10px;
        line-height: 20px;
    }
    .order-detail-body {
        border: 1px solid #d8d8d8;
        padding: 25px 35px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .order-detail-body-item {
            &:not(:only-child) {
                max-width: 40%;
            }
            .tracking_number {
                font-weight: 600;
                color: $color-primary-blue;
                cursor: pointer;
                margin-bottom: 8px;
                display: inline-block;
                .el-icon-link {
                    font-size: 18px;
                }
                &:active {
                    opacity: 0.8;
                }
            }
        }
        .order-detail-body-title {
            font-size: 17px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .order-detail-body-label {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .order-detail-body-value {
            font-size: 13px;
            margin-bottom: 8px;
            line-height: 20px;
        }

        .order-detail-body-value + .order-detail-body-label {
            margin-top: 20px;
        }
    }
    .table-wrapper {
        margin-bottom: 20px;
        ::v-deep .header-cell-class-name {
            background-color: transparent;
            font-size: 14px;
            color: $color-333333 !important;
            &:nth-child(3),
            &:nth-child(4) {
                text-align: right;
            }
        }
        ::v-deep .cell-class-name {
            vertical-align: top;
            font-size: 14px;
            &:nth-child(3),
            &:nth-child(4) {
                text-align: right;
            }
            .el-input-number {
                width: 120px;
            }
            .el-icon-delete {
                font-size: 20px;
                cursor: pointer;
                &:active {
                    opacity: 0.6;
                }
            }
        }
        .goods-info-wrapper {
            display: flex;
            ::v-deep .el-image {
                width: 80px;
                height: 80px;
                flex-shrink: 0;
                align-self: start;
            }
            .info-wrapper {
                margin-left: 20px;
                font-size: 13px;
                max-width: 340px;
                color: #000000;
                .goods-name {
                    color: $color-333333;
                    margin-bottom: 5px;
                }
                .sku-div {
                    display: flex;
                    align-items: center;
                    & span:first-of-type {
                        color: $color-333333;
                        margin-right: 12px;
                    }
                    .sku {
                        display: inline-block;
                        max-width: 260px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .warning-svg,
                    .source-svg {
                        /* position: relative;
                        left: 5px;
                        top: 1px; */
                        margin: 1px 0 0 5px;
                        width: 16px;
                        height: 16px;
                    }
                    .tip{
                        color:rgb(252, 247, 247);
                        background-color: #969494;
                        border: 1px solid #969494;
                        border-radius: 12px;
                        align-self: center;
                        display: flex;
                        align-items: center;
                        padding:0 5px;
                        margin-left:5px;
                    }
                }
                .delivery-type {
                    padding: 0px 10px;
                    border-radius: 999px;
                    height: 20px;
                    color: $color-white;
                    background-color: $color-danger;
                    line-height: 20px;
                    margin: 0 0 0 10px;
                }
                .goods-attribute {
                    // margin-top: 5px;
                    font-size: 13px;
                    display: flex;
                    color: $color-333333;
                    .goods-attribute-label {
                        margin-right: 10px;
                        flex-shrink: 0;
                    }
                    .goods-attribute-value {
                        .detail-thumb {
                            width: 16px;
                            color: #000000;
                            font-size: 16px;
                            -webkit-animation: pulsate-bck 1s ease-in-out
                                infinite both;
                            animation: pulsate-bck 1s ease-in-out infinite both;
                            &:hover {
                                animation: none;
                            }
                        }
                    }
                }
                .goods-remark {
                    margin-top: 10px;
                    width: 100%;
                    min-height: 30px;
                    line-height: 30px;
                    background-color: #fbf1f1;
                    padding: 0 10px 0 15px;
                }
                .tooltip_photo_set {
                    display: flex;
                }
            }
        }
    }
    .checkout-wrapper {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 60px;
        .checkout-box {
            min-width: 250px;
            max-width: 300px;
            padding: 10px;
            > div:not(:last-child) {
                margin-bottom: 20px;
            }
            .subtotal {
                font-size: 13px;
                display: flex;
                justify-content: space-between;
                &-label {
                    color: $color-808080;
                }
                /* &-value {
                    color: #9b3c44;
                } */
            }
            .total,
            .paid-amount {
                font-size: 16px;
                display: flex;
                justify-content: space-between;
                &-label {
                    color: $color-333333;
                }
                &-value {
                    color: #9b3c44;
                }
            }
            .tip {
                color: $color-333333;
                font-size: 15px;
                line-height: 22px;
            }
            .subtip {
                margin-top: 20px;
                color: #666;
                font-size: 14px;
                font-style: italic;
                line-height: 20px;
                text-align: right;
            }
        }
    }
}
</style>

<style lang="scss">
.photo_set_tooltip {
    max-width: auto;
    .tooltip_photo_set {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .el-image {
            width: 200px;
            height: 200px;
        }
    }
}
.lot_photos {
    min-width: 620px;
}

.set_tooltip {
    width: auto;
    max-width: 300px;
}
.sn{
    color:rgb(250, 62, 62)
}
</style>